<template>
    <div style="width: 100%;">
        <div class="d-flex col-12">
            <div class="form-control-label" style="white-space: pre-line;margin-left: 4px;"><span v-if="question.is_required" class="required-star mr-1">*</span>{{title}}</div>
        </div>
        <div class="col-12" v-if="question.image_file_name">
            <img class="cursor-pointer" :src="this.context.storageEndpoint + this.question.image_file_name" @click="openPhotoViewer = true"/>
        </div>
        <div class="col-12"><p class="text-muted px-1 question-description" v-html="formattedText"></p></div>
        <div v-if="!hasValidAnswer && showInvalid"
            class="col-12 pl-3">
            <div class="alert alert-warning">{{$t('form.please_select_file_to_upload')}}</div>
        </div>
        <div class="mb-3 px-3">
            <div v-for="k in this.fileKeys" :key="k" class="d-flex row mt-2">
                <div class="col-12 col-md-auto">
                    <div v-if="isImageFile(k) && fileStatus[k] === 'uploaded'" class="d-inline-block">
                        <img @click="openLargeImage" class="image-preview flex-grow-0" :ref="'img-' + k"  :src="context.storageEndpoint + filePath[k]" />
                    </div>
                    <span v-else-if="fileStatus[k] === 'uploaded'">{{fileNames[k]}}</span>
                    <loading-indicator
                        v-else
                        :full-parent="false"
                        :clear-background="true"
                        :is-loading="true"></loading-indicator>
                </div>
                <div class="col-12 col-md-8">
                    <editable-text
                        v-if="fileStatus[k] === 'uploaded'"
                        @input="(value) => { updateText(k, value) }"
                        :doneOnBlur="true"
                        :text="fileCaption[k]"
                        outerWrapperClass="form-control image-caption flex-grow-1 mx-0 my-1 h-auto"
                        :editInputClass="'form-control'"
                        :doneButtonClass="'btn btn-primary btn-block mt-1 btn-sm'"
                        :placeholder="$t('form.click_to_enter_file_caption')"
                        :useTextarea="true" />
                    <button
                        v-if="fileStatus[k] === 'uploaded'"
                        class="btn btn-sm btn-danger" @click="deleteFile(k)">{{$t('general.delete')}}</button>
                </div>
            </div>
        </div>
        <p class="col-12 pl-3">
            <button class="btn btn-primary btn-sm" @click="$refs['file-input'].click()">{{$t('form.select_file')}}</button>
            <span class="d-block text-muted mt-1 mb-0">
                {{$tc('form.n_selected_files_suppoprted', this.fileKeys.length, {count: this.fileKeys.length})}}
                /
                {{$tc('form.max_n_files_suppoprted', this.content.data.max_file_count, { count: this.content.data.max_file_count})}}
                {{$t('form.upload_accept_type_' + this.content.data.file_type) }}
            </span>
            <input type="file" class="d-none" multiple ref="file-input" @change="onFileChange" :accept="fileAccept" />
        </p>
        <photo-viewer
            v-if="openPhotoViewer"
            ref="photoViewer"
            :photos="photo"
            :context="context"
            @close="openPhotoViewer = false"></photo-viewer>
    </div>
</template>

<script>
import Constants from '../../constants';
import processImage from '../../mixins/process-image';
import api from '../../mixins/api';
import loadingIndicator from '../../components/common/LoadingIndicator';
import promptAlert from '../../mixins/prompt-confirm';
import _ from 'lodash';
import { EventUploadFile } from '../../bu/models/GA4';
import PhotoViewer from '../common/PhotoViewer.vue';

export default {
    mixins: [processImage, api, promptAlert],
    components: { loadingIndicator, PhotoViewer },
    props: ['question', 'providerId', 'context', 'answer'],
    data() {
        var fileCaption = {}, fileType = {}, fileStatus = {}, filePath = {}, fileNames = {};
        var fileKeys = [];
        if (this.answer && this.answer.parsedContent && this.answer.parsedContent.files) {
            this.answer.parsedContent.files.forEach((f) => {
                let key = _.uniqueId();
                fileCaption[key] = f.caption;
                fileType[key] = f.type;
                filePath[key] = f.path;
                fileStatus[key] = 'uploaded';
                fileNames[key] = f.name;
                fileKeys.push(key);
            });
        }

        return {
            id: this.question.id,
            content: this.question.content,
            status: this.question.status,
            adminQuestion: this.question.question,
            Constants,
            showInvalid: false,
            selectedFiles: [],
            fileKeys,
            fileCaption,
            fileType,
            fileStatus,
            filePath,
            fileNames,
            openPhotoViewer: false
        };
    },

    computed: {
        fileAccept() {
            if (this.content.data.file_type === 'image') {
                return 'image/jpeg,image/png';
            } else {
                return '.pdf';
            }
        },
        title: function() {
            return this.content.meta.title || '';
        },

        photo() {
            if (this.question.image_file_name) {
                return [{
                    path: this.question.image_file_name
                }];
            } else {
                return [];
            }
        },

        hasAnswer() {
            return this.fileKeys.length > 0;
        },

        hasValidAnswer() {
            return this.fileKeys.length > 0;
        },
        formattedText() {
            const text = this.content.data.text;
            return text.nl2brIfNotHTML();
        }
    },

    methods: {
        updateText(k, text) {
            this.fileCaption[k] = text;
        },
        openLargeImage(e) {
            var image = new Image();
            image.src = e.target.src;
            var w = window.open("");
            w.document.write(image.outerHTML);
        },
        isImageFile(key) {
            return this.fileType[key].match(/image/) || (['jpg', 'jpeg', 'png', 'gif'].indexOf(this.fileType[key]) >= 0);
        },
        highlightInvalidState() {
            this.showInvalid = true;
        },

        getDataToPersist() {
            return {
                question_id: this.id,
                answer_id: this.answer ? this.answer.id : null,
                answer: {
                    files: this.fileKeys.map((k) => {
                        return {
                            caption: this.fileCaption[k],
                            path: this.filePath[k],
                            type: this.fileType[k],
                            name: this.fileNames[k]
                        }
                    })
                }
            };
        },
        onFileChange(e) {
            if (e.target.files.length === 0) {
                return;
            }

            if (this.fileKeys.length + e.target.files.length > this.content.data.max_file_count) {
                this.promptAlert(this.$t('form.too_many_files'))
                $(e.target).val(null);
                return;
            }

            var oversizedFiles = [];
            for (var i = 0 ; i < e.target.files.length ; i++) {
                let f = e.target.files[i];
                let sizeMB = Math.round(f.size / 1000000 * 10) / 10;
                if (sizeMB > Constants.Defaults.MaxUploadFileSizeMB) {
                    oversizedFiles.push(f);
                    continue;
                }

                this.selectedFiles.push(f);
                f.key = _.uniqueId();
                let type = f.type.split('/')[1];
                this.$set(this.fileCaption, f.key, '');
                this.$set(this.fileType, f.key, type);
                this.$set(this.fileStatus, f.key, 'preparing');
                this.$set(this.filePath, f.key, '');
                this.$set(this.fileNames, f.key, f.name);
                this.fileKeys.push(f.key);

                if (type === 'pdf') {
                    this.uploadFile(f.key, f);
                } else {
                    // images
                    this.loadImageWithOrientationFixed(f, (canvas) => {
                        let dataURL = canvas.toDataURL(f.type, 0.9);
                        this.uploadFile(f.key, this.dataURItoBlob(dataURL));
                    }, {maxWidth: 640, maxHeight: 640});
                }
            }
            if (oversizedFiles.length > 0) {
                let fileNames = _.map(oversizedFiles, (item) => { return item.name}).join(', ');
                this.promptAlert(this.$t('message.files_should_smaller_than_25_mb', {fileNames: fileNames}));
            }

            $(e.target).val(null);
        },
        deleteFile(k) {
            let path = this.filePath[k];
            if (!path) {
                return;
            }

            this.deleteCustomerAsset(path, (response, error) => {
                //NOOP
            });
            this.selectedFiles = this.selectedFiles.filter((item) => {
                return item.key !== k;
            });
            this.fileKeys = this.fileKeys.filter((key) => {
                return k !== key ;
            })
            delete this.fileCaption[k];
            delete this.fileType[k];
            delete this.fileStatus[k];
            delete this.filePath[k];
        },
        uploadFile(fileKey, f) {
            this.fileStatus[fileKey] = 'uploading';
            this.uploadCustomerAsset(f, (response, error) => {
                if (response && response.data) {
                    this.filePath[fileKey] = response.data;
                    this.fileStatus[fileKey] = 'uploaded';
                    this.trackUploadFile();
                } else {
                    this.selectedFiles = this.selectedFiles.filter((item) => {
                        return item.key !== fileKey;
                    });
                    this.fileKeys = this.fileKeys.filter((k) => {
                        return k !== f.key ;
                    })
                    delete this.fileCaption[fileKey];
                    delete this.fileType[fileKey];
                    delete this.fileStatus[fileKey];
                    delete this.filePath[fileKey];
                }
            })
        },
        trackUploadFile() {
            window.tracker.track(() => new EventUploadFile());
        }
    }
}
</script>

<style scoped>
.required-star {
    color: red;
    font-weight: bold;
}

textarea {
    margin: 1em auto;
    width: 96%;
}

img {
    max-width: max-content;
    width: 100%;
    border-radius: 4px;
}

.image-preview {
    width: 100px;
}

.image-caption {
    display: inline-block;
}
</style>
